import { WorkflowsDemoBase } from "../WorkflowsDemoBase";
import { SOFTWARE_DEV_WORKFLOW_CONFIG } from "../workflowsDemoData";

export function SoftwareDevWorkflowsDemo() {
  return <WorkflowsDemoBase {...SOFTWARE_DEV_WORKFLOW_CONFIG} />;
}
